
<div class="wrapper">
  <div class="content-wrapper">
    <div class="br-section-wrapper">
      <!-- <div class="header_frm">
        <h2>Dashboard</h2>
      </div> -->
      <div>
        <!-- <app-price-shuffle></app-price-shuffle> -->
        <h1>Dashboard.... Comming soon!</h1>
        <!-- <app-dynamic-chart></app-dynamic-chart> -->
      </div>
    </div>
  </div>
</div>
